document.addEventListener('DOMContentLoaded', function() {
  // Updated Terminal Data with Pre-calculated Coordinates for instant results
  const terminalData = [
    {"zip":"35214","state":"AL","city":"Birmingham", lat: 33.56, lon: -86.91},
    {"zip":"36869","state":"AL","city":"Phenix City", lat: 32.47, lon: -85.00},
    {"zip":"36303","state":"AL","city":"Dothan", lat: 31.25, lon: -85.40},
    {"zip":"35756","state":"AL","city":"Madison", lat: 34.69, lon: -86.74},
    {"zip":"36619","state":"AL","city":"Mobile", lat: 30.60, lon: -88.15},
    {"zip":"36105","state":"AL","city":"Montgomery", lat: 32.32, lon: -86.31},
    {"zip":"T1X0K2","state":"AB","city":"Rocky View", lat: 51.10, lon: -113.93},
    {"zip":"T8V3J9","state":"AB","city":"Grande Prairie", lat: 55.17, lon: -118.79},
    {"zip":"T1H0P2","state":"AB","city":"Lethbridge", lat: 49.71, lon: -112.81},
    {"zip":"T4P3G2","state":"AB","city":"Red Deer", lat: 52.29, lon: -113.82},
    {"zip":"86001","state":"AZ","city":"Flagstaff", lat: 35.19, lon: -111.64},
    {"zip":"85009","state":"AZ","city":"Phoenix", lat: 33.44, lon: -112.11},
    {"zip":"85705","state":"AZ","city":"Tucson", lat: 32.25, lon: -110.97},
    {"zip":"72908","state":"AR","city":"Fort Smith", lat: 35.31, lon: -94.37},
    {"zip":"72401","state":"AR","city":"Jonesboro", lat: 35.82, lon: -90.68},
    {"zip":"72209","state":"AR","city":"Little Rock", lat: 34.68, lon: -92.34},
    {"zip":"V4V1S5","state":"BC","city":"Kelowna", lat: 50.02, lon: -119.39},
    {"zip":"V3V3V7","state":"BC","city":"Surrey", lat: 49.19, lon: -122.85},
    {"zip":"93313","state":"CA","city":"Bakersfield", lat: 35.29, lon: -119.03},
    {"zip":"92243","state":"CA","city":"El Centro", lat: 32.78, lon: -115.57},
    {"zip":"92337","state":"CA","city":"Fontana", lat: 34.06, lon: -117.47},
    {"zip":"93725","state":"CA","city":"Fresno", lat: 36.68, lon: -119.72},
    {"zip":"90805","state":"CA","city":"Long Beach", lat: 33.87, lon: -118.17},
    {"zip":"90058","state":"CA","city":"Vernon", lat: 34.00, lon: -118.22},
    {"zip":"94577","state":"CA","city":"San Leandro", lat: 37.71, lon: -122.15},
    {"zip":"90248","state":"CA","city":"Gardena", lat: 33.87, lon: -118.28},
    {"zip":"96001","state":"CA","city":"Redding", lat: 40.57, lon: -122.37},
    {"zip":"95624","state":"CA","city":"Elk Grove", lat: 38.41, lon: -121.35},
    {"zip":"92064","state":"CA","city":"Poway", lat: 32.96, lon: -117.03},
    {"zip":"95112","state":"CA","city":"San Jose", lat: 37.35, lon: -121.87},
    {"zip":"93454","state":"CA","city":"Santa Maria", lat: 34.94, lon: -120.42},
    {"zip":"94931","state":"CA","city":"Cotati", lat: 38.33, lon: -122.70},
    {"zip":"80907","state":"CO","city":"Colorado Springs", lat: 38.87, lon: -104.82},
    {"zip":"80640","state":"CO","city":"Henderson", lat: 39.91, lon: -104.85},
    {"zip":"81501","state":"CO","city":"Grand Junction", lat: 39.08, lon: -108.55},
    {"zip":"33905","state":"FL","city":"Fort Myers", lat: 26.67, lon: -81.79},
    {"zip":"32218","state":"FL","city":"Jacksonville", lat: 30.45, lon: -81.65},
    {"zip":"33167","state":"FL","city":"Miami", lat: 25.88, lon: -80.22},
    {"zip":"34482","state":"FL","city":"Ocala", lat: 29.19, lon: -82.21},
    {"zip":"32824","state":"FL","city":"Orlando", lat: 28.39, lon: -81.35},
    {"zip":"32505","state":"FL","city":"Pensacola", lat: 30.45, lon: -87.25},
    {"zip":"32304","state":"FL","city":"Tallahassee", lat: 30.45, lon: -84.34},
    {"zip":"33619","state":"FL","city":"Tampa", lat: 27.93, lon: -82.38},
    {"zip":"33407","state":"FL","city":"West Palm Beach", lat: 26.74, lon: -80.08},
    {"zip":"30601","state":"GA","city":"Athens", lat: 33.96, lon: -83.37},
    {"zip":"30294","state":"GA","city":"Ellenwood", lat: 33.60, lon: -84.28},
    {"zip":"31408","state":"GA","city":"Garden City", lat: 32.11, lon: -81.16},
    {"zip":"31794","state":"GA","city":"Tifton", lat: 31.48, lon: -83.51},
    {"zip":"83705","state":"ID","city":"Boise", lat: 43.57, lon: -116.21},
    {"zip":"83201","state":"ID","city":"Pocatello", lat: 42.90, lon: -112.45},
    {"zip":"83301","state":"ID","city":"Twin Falls", lat: 42.56, lon: -114.46},
    {"zip":"61704","state":"IL","city":"Bloomington", lat: 40.46, lon: -88.95},
    {"zip":"60527","state":"IL","city":"Burr Ridge", lat: 41.74, lon: -87.91},
    {"zip":"62467","state":"IL","city":"Teutopolis", lat: 39.13, lon: -88.47},
    {"zip":"60060","state":"IL","city":"Mundelein", lat: 42.26, lon: -88.00},
    {"zip":"47710","state":"IN","city":"Evansville", lat: 38.00, lon: -87.56},
    {"zip":"46806","state":"IN","city":"Fort Wayne", lat: 41.04, lon: -85.11},
    {"zip":"46241","state":"IN","city":"Indianapolis", lat: 39.73, lon: -86.25},
    {"zip":"46628","state":"IN","city":"South Bend", lat: 41.71, lon: -86.30},
    {"zip":"52404","state":"IA","city":"Cedar Rapids", lat: 41.93, lon: -91.70},
    {"zip":"50313","state":"IA","city":"Des Moines", lat: 41.65, lon: -93.61},
    {"zip":"51105","state":"IA","city":"Sioux City", lat: 42.49, lon: -96.38},
    {"zip":"67217","state":"KS","city":"Wichita", lat: 37.62, lon: -97.35},
    {"zip":"40511","state":"KY","city":"Lexington", lat: 38.08, lon: -84.52},
    {"zip":"40211","state":"KY","city":"Louisville", lat: 38.24, lon: -85.81},
    {"zip":"71302","state":"LA","city":"Alexandria", lat: 31.29, lon: -92.45},
    {"zip":"70805","state":"LA","city":"Baton Rouge", lat: 30.49, lon: -91.14},
    {"zip":"70363","state":"LA","city":"Houma", lat: 29.58, lon: -90.69},
    {"zip":"70518","state":"LA","city":"Broussard", lat: 30.13, lon: -91.95},
    {"zip":"70615","state":"LA","city":"Lake Charles", lat: 30.22, lon: -93.16},
    {"zip":"71202","state":"LA","city":"Monroe", lat: 32.47, lon: -92.08},
    {"zip":"70121","state":"LA","city":"Jefferson", lat: 29.96, lon: -90.15},
    {"zip":"71107","state":"LA","city":"Shreveport", lat: 32.55, lon: -93.77},
    {"zip":"20707","state":"MD","city":"Laurel", lat: 39.09, lon: -76.85},
    {"zip":"02093","state":"MA","city":"Wrentham", lat: 42.06, lon: -71.33},
    {"zip":"01104","state":"MA","city":"Springfield", lat: 42.12, lon: -72.56},
    {"zip":"01581","state":"MA","city":"Westborough", lat: 42.26, lon: -71.61},
    {"zip":"48120","state":"MI","city":"Dearborn", lat: 42.31, lon: -83.15},
    {"zip":"49509","state":"MI","city":"Wyoming", lat: 42.90, lon: -85.70},
    {"zip":"49738","state":"MI","city":"Grayling", lat: 44.66, lon: -84.71},
    {"zip":"49202","state":"MI","city":"Jackson", lat: 42.26, lon: -84.42},
    {"zip":"48601","state":"MI","city":"Saginaw", lat: 43.40, lon: -83.93},
    {"zip":"55112","state":"MN","city":"Mounds View", lat: 45.10, lon: -93.20},
    {"zip":"38756","state":"MS","city":"Leland", lat: 33.40, lon: -90.89},
    {"zip":"39503","state":"MS","city":"Gulfport", lat: 30.43, lon: -89.07},
    {"zip":"39401","state":"MS","city":"Hattiesburg", lat: 31.31, lon: -89.29},
    {"zip":"39218","state":"MS","city":"Richland", lat: 32.23, lon: -90.16},
    {"zip":"38826","state":"MS","city":"Belden", lat: 34.30, lon: -88.78},
    {"zip":"64120","state":"MO","city":"Kansas City", lat: 39.13, lon: -94.51},
    {"zip":"63376","state":"MO","city":"Saint Peters", lat: 38.79, lon: -90.62},
    {"zip":"65757","state":"MO","city":"Strafford", lat: 37.26, lon: -93.11},
    {"zip":"68514","state":"NE","city":"Lincoln", lat: 40.75, lon: -96.76},
    {"zip":"68702","state":"NE","city":"Norfolk", lat: 42.03, lon: -97.42},
    {"zip":"68117","state":"NE","city":"Omaha", lat: 41.20, lon: -95.96},
    {"zip":"89081","state":"NV","city":"North Las Vegas", lat: 36.24, lon: -115.11},
    {"zip":"89431","state":"NV","city":"Sparks", lat: 39.54, lon: -119.75},
    {"zip":"E2A1Y7","state":"NB","city":"Bathurst", lat: 47.62, lon: -65.65},
    {"zip":"E3N4E8","state":"NB","city":"Atholville", lat: 47.98, lon: -66.71},
    {"zip":"E3C2B2","state":"NB","city":"Hanwell", lat: 45.90, lon: -66.73},
    {"zip":"E3E1B6","state":"NB","city":"Grand Falls", lat: 47.04, lon: -67.73},
    {"zip":"E1N6C5","state":"NB","city":"Miramichi", lat: 47.02, lon: -65.46},
    {"zip":"E1E2L4","state":"NB","city":"Moncton", lat: 46.09, lon: -64.83},
    {"zip":"E2L5Y4","state":"NB","city":"Saint John", lat: 45.28, lon: -66.06},
    {"zip":"E4E2G2","state":"NB","city":"Sussex", lat: 45.72, lon: -65.50},
    {"zip":"E1X1A4","state":"NB","city":"Tracadie", lat: 47.51, lon: -64.91},
    {"zip":"E7M2H5","state":"NB","city":"Woodstock", lat: 46.15, lon: -67.58},
    {"zip":"03301","state":"NH","city":"Concord", lat: 43.20, lon: -71.53},
    {"zip":"07105","state":"NJ","city":"Newark", lat: 40.72, lon: -74.14},
    {"zip":"08110","state":"NJ","city":"Pennsauken", lat: 39.97, lon: -75.06},
    {"zip":"87121","state":"NM","city":"Albuquerque", lat: 35.05, lon: -106.75},
    {"zip":"87401","state":"NM","city":"Farmington", lat: 36.75, lon: -108.18},
    {"zip":"12205","state":"NY","city":"Colonie", lat: 42.71, lon: -73.82},
    {"zip":"12575","state":"NY","city":"Rock Tavern", lat: 41.50, lon: -74.13},
    {"zip":"14624","state":"NY","city":"Rochester", lat: 43.12, lon: -77.71},
    {"zip":"13211","state":"NY","city":"Syracuse", lat: 43.10, lon: -76.13},
    {"zip":"A2H6J3","state":"NL","city":"Corner Brook", lat: 48.94, lon: -57.92},
    {"zip":"A2A1C6","state":"NL","city":"Windsor", lat: 48.94, lon: -55.65},
    {"zip":"A0P1E0","state":"NL","city":"Happy Valley-Goose Bay", lat: 53.30, lon: -60.32},
    {"zip":"A0R1B0","state":"NL","city":"Wabush", lat: 52.91, lon: -66.86},
    {"zip":"A0K4S0","state":"NL","city":"St. Anthony", lat: 51.36, lon: -55.60},
    {"zip":"A1L1C3","state":"NL","city":"Paradise", lat: 47.53, lon: -52.84},
    {"zip":"28206","state":"NC","city":"Charlotte", lat: 35.25, lon: -80.82},
    {"zip":"28348","state":"NC","city":"Hope Mills", lat: 34.97, lon: -78.93},
    {"zip":"27406","state":"NC","city":"Greensboro", lat: 36.01, lon: -79.79},
    {"zip":"27834","state":"NC","city":"Greenville", lat: 35.60, lon: -77.40},
    {"zip":"28613","state":"NC","city":"Conover", lat: 35.71, lon: -81.23},
    {"zip":"27617","state":"NC","city":"Raleigh", lat: 35.89, lon: -78.75},
    {"zip":"B4V2W4","state":"NS","city":"Bridgewater", lat: 44.38, lon: -64.52},
    {"zip":"B3B0G3","state":"NS","city":"Dartmouth", lat: 44.71, lon: -63.59},
    {"zip":"B4N3V7","state":"NS","city":"Kentville", lat: 45.07, lon: -64.49},
    {"zip":"B2H5C6","state":"NS","city":"New Glasgow", lat: 45.59, lon: -62.65},
    {"zip":"B1P6H2","state":"NS","city":"Sydney", lat: 46.13, lon: -60.17},
    {"zip":"B2N0A8","state":"NS","city":"Truro", lat: 45.36, lon: -63.28},
    {"zip":"B5A3K1","state":"NS","city":"Yarmouth", lat: 43.83, lon: -66.11},
    {"zip":"45069","state":"OH","city":"West Chester", lat: 39.33, lon: -84.40},
    {"zip":"44286","state":"OH","city":"Richfield", lat: 41.24, lon: -81.63},
    {"zip":"43228","state":"OH","city":"Columbus", lat: 39.95, lon: -83.13},
    {"zip":"45404","state":"OH","city":"Riverside", lat: 39.78, lon: -84.14},
    {"zip":"44906","state":"OH","city":"Mansfield", lat: 40.76, lon: -82.57},
    {"zip":"43608","state":"OH","city":"Toledo", lat: 41.68, lon: -83.53},
    {"zip":"73129","state":"OK","city":"Oklahoma City", lat: 35.43, lon: -97.49},
    {"zip":"74145","state":"OK","city":"Tulsa", lat: 36.09, lon: -95.86},
    {"zip":"L9X1L2","state":"ON","city":"Midhurst", lat: 44.44, lon: -79.73},
    {"zip":"N1T1N6","state":"ON","city":"Cambridge", lat: 43.40, lon: -80.30},
    {"zip":"P8N3G2","state":"ON","city":"Dryden", lat: 49.78, lon: -92.83},
    {"zip":"P9A3L4","state":"ON","city":"Fort Frances", lat: 48.61, lon: -93.40},
    {"zip":"P9N1L8","state":"ON","city":"Kenora / Keewatin", lat: 49.76, lon: -94.49},
    {"zip":"K7L5C4","state":"ON","city":"Kingston", lat: 44.24, lon: -76.51},
    {"zip":"P2N3H7","state":"ON","city":"Kirkland Lake", lat: 48.14, lon: -80.03},
    {"zip":"N6E2Z3","state":"ON","city":"London", lat: 42.92, lon: -81.21},
    {"zip":"P0J1P0","state":"ON","city":"New Liskeard", lat: 47.51, lon: -79.67},
    {"zip":"P1B2S4","state":"ON","city":"North Bay", lat: 46.32, lon: -79.44},
    {"zip":"L1J7E2","state":"ON","city":"Oshawa", lat: 43.89, lon: -78.87},
    {"zip":"K1B5L2","state":"ON","city":"Gloucester", lat: 45.41, lon: -75.58},
    {"zip":"P0V2M0","state":"ON","city":"Red Lake", lat: 51.02, lon: -93.83},
    {"zip":"P6B3M1","state":"ON","city":"Sault Ste Marie", lat: 46.52, lon: -84.30},
    {"zip":"P3Y1L4","state":"ON","city":"Sudbury", lat: 46.43, lon: -81.08},
    {"zip":"P7B6S4","state":"ON","city":"Thunder Bay", lat: 48.43, lon: -89.25},
    {"zip":"P4N7J5","state":"ON","city":"Timmins", lat: 48.48, lon: -81.33},
    {"zip":"L4W1G5","state":"ON","city":"Toronto", lat: 43.66, lon: -79.60},
    {"zip":"P0S1K0","state":"ON","city":"Wawa", lat: 47.99, lon: -84.77},
    {"zip":"N9C3S2","state":"ON","city":"Windsor", lat: 42.29, lon: -83.05},
    {"zip":"97756","state":"OR","city":"Redmond", lat: 44.27, lon: -121.17},
    {"zip":"97403","state":"OR","city":"Eugene", lat: 44.04, lon: -123.06},
    {"zip":"97502","state":"OR","city":"Central Point", lat: 42.37, lon: -122.91},
    {"zip":"97217","state":"OR","city":"Portland", lat: 45.59, lon: -122.69},
    {"zip":"18017","state":"PA","city":"Bethlehem", lat: 40.65, lon: -75.36},
    {"zip":"16635","state":"PA","city":"Duncansville", lat: 40.42, lon: -78.43},
    {"zip":"16511","state":"PA","city":"Erie", lat: 42.15, lon: -80.02},
    {"zip":"17015","state":"PA","city":"Carlisle", lat: 40.20, lon: -77.17},
    {"zip":"15301","state":"PA","city":"Washington", lat: 40.17, lon: -80.25},
    {"zip":"18702","state":"PA","city":"Wilkes Barre", lat: 41.23, lon: -75.87},
    {"zip":"C1E1Z2","state":"PEI","city":"Winsloe", lat: 46.28, lon: -63.18},
    {"zip":"G4Z1T5","state":"QC","city":"Baie Comeau", lat: 49.20, lon: -68.15},
    {"zip":"G9A2T6","state":"QC","city":"Trois Rivieres", lat: 46.35, lon: -72.56},
    {"zip":"G7X0H5","state":"QC","city":"Jonquiere", lat: 48.41, lon: -71.25},
    {"zip":"J2C5Y4","state":"QC","city":"Drummondville", lat: 45.88, lon: -72.49},
    {"zip":"G4W0J3","state":"QC","city":"Matane", lat: 48.84, lon: -67.51},
    {"zip":"G0E1T0","state":"QC","city":"Mont-Louis", lat: 49.23, lon: -65.73},
    {"zip":"H4S1B7","state":"QC","city":"Saint-Laurent", lat: 45.49, lon: -73.71},
    {"zip":"G0C2B0","state":"QC","city":"New Richmond", lat: 48.16, lon: -65.86},
    {"zip":"G5M1S8","state":"QC","city":"Rimouski", lat: 48.43, lon: -68.50},
    {"zip":"G0L2K0","state":"QC","city":"Saint-Arsene", lat: 47.94, lon: -69.38},
    {"zip":"J9X7C8","state":"QC","city":"Rouyn-Noranda", lat: 48.24, lon: -79.02},
    {"zip":"G4R4X7","state":"QC","city":"Sept-Iles", lat: 50.22, lon: -66.38},
    {"zip":"J9P6X2","state":"QC","city":"Val D'Or", lat: 48.10, lon: -77.78},
    {"zip":"S0G5K0","state":"SK","city":"Zehner", lat: 50.62, lon: -104.45},
    {"zip":"S7R1B3","state":"SK","city":"Saskatoon", lat: 52.17, lon: -106.75},
    {"zip":"29841","state":"SC","city":"North Augusta", lat: 33.52, lon: -81.96},
    {"zip":"29410","state":"SC","city":"Hanahan", lat: 32.91, lon: -80.00},
    {"zip":"29033","state":"SC","city":"Cayce", lat: 33.96, lon: -81.07},
    {"zip":"29501","state":"SC","city":"Florence", lat: 34.19, lon: -79.79},
    {"zip":"29650","state":"SC","city":"Greer", lat: 34.93, lon: -82.23},
    {"zip":"57104","state":"SD","city":"Sioux Falls", lat: 43.56, lon: -96.72},
    {"zip":"37407","state":"TN","city":"Chattanooga", lat: 35.00, lon: -85.28},
    {"zip":"38301","state":"TN","city":"Jackson", lat: 35.63, lon: -88.82},
    {"zip":"37664","state":"TN","city":"Kingsport", lat: 36.52, lon: -82.52},
    {"zip":"37921","state":"TN","city":"Knoxville", lat: 35.98, lon: -83.98},
    {"zip":"38116","state":"TN","city":"Memphis", lat: 35.03, lon: -89.98},
    {"zip":"37086","state":"TN","city":"La Vergne", lat: 36.00, lon: -86.57},
    {"zip":"79606","state":"TX","city":"Abilene", lat: 32.39, lon: -99.76},
    {"zip":"79103","state":"TX","city":"Amarillo", lat: 35.19, lon: -101.80},
    {"zip":"78753","state":"TX","city":"Austin", lat: 30.37, lon: -97.68},
    {"zip":"77701","state":"TX","city":"Beaumont", lat: 30.08, lon: -94.10},
    {"zip":"78408","state":"TX","city":"Corpus Christi", lat: 27.78, lon: -97.44},
    {"zip":"75050","state":"TX","city":"Grand Prairie", lat: 32.72, lon: -97.02},
    {"zip":"79905","state":"TX","city":"El Paso", lat: 31.77, lon: -106.43},
    {"zip":"76052","state":"TX","city":"Fort Worth", lat: 32.91, lon: -97.33},
    {"zip":"75212","state":"TX","city":"Dallas", lat: 32.78, lon: -96.88},
    {"zip":"78559","state":"TX","city":"La Feria", lat: 26.15, lon: -97.82},
    {"zip":"77078","state":"TX","city":"Houston", lat: 29.86, lon: -95.25},
    {"zip":"78045","state":"TX","city":"Laredo", lat: 27.59, lon: -99.49},
    {"zip":"79404","state":"TX","city":"Lubbock", lat: 33.55, lon: -101.83},
    {"zip":"79763","state":"TX","city":"Odessa", lat: 31.84, lon: -102.39},
    {"zip":"78219","state":"TX","city":"San Antonio", lat: 29.43, lon: -98.41},
    {"zip":"75092","state":"TX","city":"Sherman", lat: 33.64, lon: -96.62},
    {"zip":"75702","state":"TX","city":"Tyler", lat: 32.37, lon: -95.31},
    {"zip":"77905","state":"TX","city":"Victoria", lat: 28.84, lon: -96.96},
    {"zip":"76706","state":"TX","city":"Robinson", lat: 31.47, lon: -97.11},
    {"zip":"76305","state":"TX","city":"Wichita Falls", lat: 33.95, lon: -98.56},
    {"zip":"84104","state":"UT","city":"Salt Lake City", lat: 40.75, lon: -111.93},
    {"zip":"23323","state":"VA","city":"Chesapeake", lat: 36.72, lon: -76.37},
    {"zip":"23836","state":"VA","city":"Chester", lat: 37.32, lon: -77.38},
    {"zip":"24153","state":"VA","city":"SALEM", lat: 37.28, lon: -80.05},
    {"zip":"99301","state":"WA","city":"Pasco", lat: 46.25, lon: -119.12},
    {"zip":"98032","state":"WA","city":"Kent", lat: 47.39, lon: -122.25},
    {"zip":"99212","state":"WA","city":"Spokane", lat: 47.67, lon: -117.29},
    {"zip":"98424","state":"WA","city":"Fife", lat: 47.23, lon: -122.36},
    {"zip":"54115","state":"WI","city":"De Pere", lat: 44.43, lon: -88.08},
    {"zip":"53597","state":"WI","city":"Waunakee", lat: 43.19, lon: -89.44},
    {"zip":"53221","state":"WI","city":"Milwaukee", lat: 42.96, lon: -87.95},
    {"zip":"54401","state":"WI","city":"Wausau", lat: 44.96, lon: -89.64}
  ];

    // UI ELEMENTS
    const inputEl = document.getElementById('user-zip');
    const btnEl = document.getElementById('find-terminal-btn');
    const typeEl = document.getElementById('shipment-type');
    const loadingEl = document.getElementById('tf-loading');
    const resultEl = document.getElementById('tf-result');
    const errorEl = document.getElementById('tf-error');
    const nameDisplay = document.getElementById('terminal-name');
    const zipDisplay = document.getElementById('terminal-zip');
    const priceDisplay = document.getElementById('terminal-price');
    const resultHead = document.querySelector('.tf-result-head');
    const priceLabel = document.querySelector('.tf-price-label');
    const priceSuffix = document.querySelector('.tf-amount-suffix');

    if (inputEl) inputEl.setAttribute('maxlength', '7');

    /* --- GEO & DISTANCE FUNCTIONS --- */
    async function getCoordinates(postal) {
        try {
            const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&postalcode=${postal}&countrycodes=us,ca&limit=1`);
            const data = await response.json();
            return (data && data.length) ? { lat: parseFloat(data[0].lat), lon: parseFloat(data[0].lon) } : null;
        } catch (e) { return null; }
    }

    function getDistance(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    }

    /* --- PRICING MATRIX --- */
    const pricingMatrix = {
        "Tier-High": { base: 350, frontCut: 550, states: ['CA','WA','OR','BC','AB','SK','FL','TX','AZ','NM','NV','UT'] },
        "Tier-Mid": { base: 295, frontCut: 450, states: ['ID','MT','CO','WY','ME','VT','NH','MA','RI','CT','NJ','MD','DE','GA','SC','NC','VA','LA','OK','KS','NE','SD','ND','QC','NB','NS','PEI'] },
        "Tier-Base": { base: 250, frontCut: 350, states: ['IL','IN','OH','KY','MI','PA','TN','MO','WI','IA','MN','WV','AL'] }
    };

    /* --- MAIN CALCULATOR --- */
    async function calculateRate(userZip, shipmentType) {
        const rawVal = userZip.trim().toUpperCase().replace(/\s+/g,'');
        if (rawVal.length < 3) return null;

        if (rawVal.startsWith("L")) {
            return {
                price: 100, currency: "CAD", label: "Local Shop Delivery:", priceLabel: "Local Delivery Rate",
                note: "Handled directly by our warehouse team.", location: "delivery within the GTA (Greater Toronto Area)", zip: rawVal
            };
        }

        const userCoords = await getCoordinates(rawVal);
        if (!userCoords) return null;

        let nearest = null; let shortest = Infinity;
        if (typeof terminalData === 'undefined') {
            console.error("terminalData is missing!");
            return null;
        }

        for (let terminal of terminalData) {
            const dist = getDistance(userCoords.lat, userCoords.lon, terminal.lat, terminal.lon);
            if (dist < shortest) { shortest = dist; nearest = terminal; }
        }

        if (!nearest) return null;

        let region = "Tier-Base";
        if (pricingMatrix["Tier-High"].states.includes(nearest.state)) region = "Tier-High";
        else if (pricingMatrix["Tier-Mid"].states.includes(nearest.state)) region = "Tier-Mid";

        const price = shipmentType === "front-cut" ? pricingMatrix[region].frontCut : pricingMatrix[region].base;

        return {
            price: price, currency: "USD", label: "Nearest Pickup Terminal Found:", priceLabel: "Terminal Pickup Rate",
            note: "Rate based on closest freight terminal.", location: `${nearest.city}, ${nearest.state}`, zip: nearest.zip
        };
    }

    /* --- AUTO-INJECTOR: Product Page Top Price --- */
    async function runProductPageInjection() {
        const container = document.getElementById('dynamic-shipping-price');
        if (!container) return;

        const outputSpan = container.querySelector('.price-output');
        const title = (container.getAttribute('data-product-title') || "").toLowerCase();
        
        let type = "base"; 
        if (title.includes('bumper') || title.includes('front cut') || title.includes('conversion') || title.includes('clip') || title.includes('nose')) {
            type = "front-cut";
        }

        let savedZip = localStorage.getItem('user-terminal-zip');
        
        if (!savedZip) {
            outputSpan.textContent = "Estimating shipping...";
            try {
                const response = await fetch('https://ipapi.co/json/');
                const data = await response.json();
                
                if (data.region === "Ontario" || data.city === "Brampton" || data.city === "Mississauga" || data.city === "Toronto") {
                    savedZip = "L4W";
                } else if (data.country_code === 'US' || data.country_code === 'CA') {
                    savedZip = data.postal || data.city;
                }

                if (savedZip) {
                    localStorage.setItem('user-terminal-zip', savedZip);
                } else {
                    if (data.country_code && data.country_code !== 'US' && data.country_code !== 'CA') {
                        outputSpan.textContent = "Freight Shipping is currently not available for your region.";
                        return;
                    }
                    outputSpan.textContent = "Calculated at checkout";
                    return;
                }
            } catch (err) {
                outputSpan.textContent = "Calculated at checkout";
                return;
            }
        }

        try {
            const result = await calculateRate(savedZip, type);
            if (!result) {
                outputSpan.textContent = "Calculated at checkout";
                return;
            }

            outputSpan.innerHTML = `<strong>$${result.price.toFixed(2)} ${result.currency}</strong> to ${result.location}`;
            
            const oldNote = container.querySelector('.shipping-note');
            if (oldNote) oldNote.remove();

            const note = document.createElement('div');
            note.className = 'shipping-note';
            note.style.cssText = 'font-size: 12px; margin-top: 4px; color: #555;';
            note.innerHTML = `<i class="fa fa-truck"></i> ${result.priceLabel}`;
            container.appendChild(note);
            
        } catch (e) {
            outputSpan.textContent = "Calculated at checkout";
        }
    }

    /* --- UI HANDLER (MANUAL TOOL) --- */
    async function handleCalculate(e) {
        if (e) e.preventDefault();
        errorEl.style.display = "none"; 
        resultEl.style.display = "none"; 
        loadingEl.style.display = "block";
        
        const result = await calculateRate(inputEl.value, typeEl.value);
        loadingEl.style.display = "none";

        if (!result) { 
            errorEl.style.display = "block"; 
            return; 
        }

        localStorage.setItem('user-terminal-zip', inputEl.value);
        resultHead.textContent = result.label;
        nameDisplay.textContent = result.location;
        zipDisplay.textContent = `Destination/Terminal: ${result.zip}`;
        if (priceLabel) priceLabel.textContent = result.priceLabel;
        if (priceSuffix) priceSuffix.textContent = result.currency;
        priceDisplay.textContent = result.price.toFixed(2);

        const instructionBox = document.querySelector('.tf-instruction');
        if (result.currency === "CAD" || result.location.includes("GTA")) {
            instructionBox.innerHTML = `<strong>Local Pickup/Delivery:</strong> Please contact our team at 11 Blair Drive to arrange a local pickup or to schedule a GTA-wide delivery.`;
            instructionBox.style.background = "#e6f7ff"; 
            instructionBox.style.borderColor = "#91d5ff";
            instructionBox.style.color = "#0050b3";
        } else {
            instructionBox.innerHTML = `<strong>Next Step:</strong> Select the <b>"$${result.price.toFixed(0)} Terminal Pickup"</b> option during checkout to lock in this rate.`;
            instructionBox.style.background = "var(--g-accent-yellow)";
            instructionBox.style.borderColor = "var(--g-accent-border)";
            instructionBox.style.color = "var(--g-accent-text)";
        }

        resultEl.style.display = "block";
        runProductPageInjection();
    }

    /* --- AUTO-SELECT DROPDOWN BASED ON PRODUCT TITLE --- */
    function autoSelectShipmentType() {
        const container = document.getElementById('terminal-finder-container');
        const dropdown = document.getElementById('shipment-type');
        if (!container || !dropdown) return;

        const title = (container.getAttribute('data-product-title') || "").toLowerCase();

        if (title.includes('bumper') || title.includes('front cut') || title.includes('conversion') || title.includes('clip') || title.includes('nose')) {
            dropdown.value = "front-cut";
        } else if (title.includes('engine') || title.includes('transmission') || title.includes('motor') || title.includes('k24') || title.includes('2zr')) {
            dropdown.value = "standard";
        }
    }

    // EVENT LISTENERS
    if (btnEl) btnEl.addEventListener("click", handleCalculate);
    if (inputEl) {
        inputEl.addEventListener("keydown", function(e) {
            if (e.key === "Enter") { e.preventDefault(); handleCalculate(); }
        });
    }

    // RUN ON LOAD
    autoSelectShipmentType();
    setTimeout(runProductPageInjection, 1000); 

});